export default __webpack_public_path__ + "static/media/logo.8340fc36.png";